import type { RefObject } from 'react'
import {
  getLineBounds,
  applyChange,
  getIndentation,
  insertAtSelection,
} from '../utils'
import { matchList, findListItemStartLine } from '../listUtils'
import { markdownConfig } from '../../config'

export type ContinueListItemOptions = {
  insertBackslashIfMissing?: boolean
  requireBackslash?: boolean
}

export const continueListItemAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
  options: ContinueListItemOptions = {
    insertBackslashIfMissing: !markdownConfig.useHardBreaks,
    requireBackslash: !markdownConfig.useHardBreaks,
  },
): boolean => {
  const el = textareaRef.current
  if (!el) return false

  let s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s

  let before = value.slice(0, s)
  const after = value.slice(e)
  const { line: lineBefore, lineStart } = getLineBounds(before, before.length)

  if (!(s > 0 && before[before.length - 1] === '\\')) {
    if (options.insertBackslashIfMissing) {
      before += '\\'
      ++s
    } else if (options.requireBackslash) return false
  }

  const currLineMatch = matchList(lineBefore)

  if (!currLineMatch && !findListItemStartLine(value, lineStart, lineBefore)) {
    return false
  }

  const indent = currLineMatch
    ? (currLineMatch[1] || '') + ' '.repeat((currLineMatch[2] || '').length)
    : getIndentation(lineBefore)

  const insert = `\n${indent}`
  const { next, caret } = insertAtSelection(before, insert, after)

  applyChange(textareaRef, onChange, next, caret)
  return true
}
